import { render, staticRenderFns } from "./rate-tier-report.vue?vue&type=template&id=2bb14172&scoped=true&"
import script from "./rate-tier-report.vue?vue&type=script&lang=js&"
export * from "./rate-tier-report.vue?vue&type=script&lang=js&"
import style0 from "./rate-tier-report.vue?vue&type=style&index=0&id=2bb14172&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb14172",
  null
  
)

export default component.exports